<candidate-profile-share-modal
  #modalProfileShare
  *ngIf="item"
  [jobPostId]="item.jobPostId"
  [candidateApplication]="item"
  [jobApplicationId]="item.id"
></candidate-profile-share-modal>

<e11-card
  (click)="!loading && candidateSelection()"
  [isClickable]="!loading"
  [status]="loading ? false : (lastApplicationViewed$ | async) === item?.id"
  id="candidateId_{{ item?.id }}"
  #candidateCard
>
  <div [ngClass]="{ 'e11-mb-4': loading }" class="e11-w-full e11-flex e11-items-center e11-justify-between">
    <div class="e11-flex e11-gap-1">
      <h3 *ngIf="!loading" class="e11-line-clamp-1 e11-mb-0 e11-text-base e11-text-skin-primary">{{ item?.firstName }} {{ item?.lastName }}</h3>
      <candidate-protection-icon
        *ngIf="showProtection && isProtected"
        [tooltipText]="'This candidate is protect from being automatically flagged as unresponsive or automatically rejected.' | translate"
        [isActive]="isProtected"
      ></candidate-protection-icon>
    </div>
    <h4 *ngIf="loading" class="e11-h3-skeleton"></h4>
    <div class="e11-flex e11-items-start e11-justify-end">
      @defer (on viewport(candidateCard)) {
      <e11-overflow
        #candidateActionOverflow
        (clickOptionEvent)="candidateActionOverflowChoice($any($event))"
        *ngIf="!loading"
        [closeOnMouseOut]="true"
        [menuMaxWidth]="160"
        [menuPosition]="'bottom left'"
        [options]="(actionOverflowOptions$ | async) ?? []"
      >
        <li
          *ngIf="!isProtected && showProtection"
          (click)="candidateActionOverflow.clickOption(candidateActions.ProtectCandidate, $event)"
          class="e11-cursor-pointer"
          custom-option
        >
          {{ candidateActions.ProtectCandidate | translate }}
        </li>
        <li
          *ngIf="isProtected && showProtection"
          (click)="candidateActionOverflow.clickOption(candidateActions.RemoveProtection, $event)"
          class="mc-menu-item-danger e11-cursor-pointer"
          custom-option
        >
          {{ candidateActions.RemoveProtection | translate }}
        </li>
        <li
          *ngIf="!(item?.applicationState | isApplicationArchived)"
          (click)="candidateActionOverflow.clickOption(candidateActions.Reject, $event)"
          class="mc-menu-item-danger e11-cursor-pointer"
          custom-option
        >
          {{ 'Reject' }}
        </li>
        <li
          *ngIf="item?.applicationState === APPLICATION_STATE.NOT_INTERESTED"
          (click)="candidateActionOverflow.clickOption(candidateActions.Reactivate, $event)"
          class="e11-cursor-pointer"
          custom-option
        >
          {{ 'Reactivate' }}
        </li>
      </e11-overflow>
      }
      <div *ngIf="loading" class="e11-skeleton-empty !e11-w-5 e11-h-5"></div>
    </div>
  </div>
  <div class="e11-w-full e11-flex e11-items-center e11-mb-2">
    <div class="e11-mr-2 e11-chart-percentage-container e11-text-center">
      @defer (on viewport(candidateCard)) {
      <e11-avatar [imageUrl]="item?.photoURL" [size]="'xl'" [hasRing]="true" [hasBorder]="false"></e11-avatar>
      }
      <div *ngIf="loading" class="e11-chart-percentage-skeleton e11-h-[68px] e11-w-[68px]"></div>
    </div>

    <div class="e11-grow">
      <div class="e11-w-full e11-flex">
        <div class="e11-grow">
          <!-- Rating -->
          <div *ngIf="!loading" class="e11-flex e11-mb-2 e11-items-center e11-gap-1 e11-h-4">
            @defer (on viewport(candidateCard)) {
            <ui-candidate-stars [starRating]="item?.starRating || 0"></ui-candidate-stars>
            }
            <span *ngIf="item?.firstImpression" class="material-icons-outlined e11-text-skin-primary-accent"> smart_display </span>
            <e11-tooltip
              *ngIf="item?.resumeAttachment"
              [tooltipClassOverrides]="'e11-text-center'"
              tooltipText="{{ 'Download the hard copy of this candidate\'s resume.' | translate }}"
            >
              <span class="material-symbols-outlined e11-text-skin-primary-accent"> article_person </span>
            </e11-tooltip>
          </div>

          <p *ngIf="!loading && item?.address !== undefined" class="e11-text-xs e11-mb-0">
            {{ item?.address | addressFormat }}
          </p>

          <div *ngIf="!loading" class="e11-flex e11-items-center e11-h-5">
            <span class="e11-truncate e11-text-xs e11-mr-1"> {{ 'Applied on' | translate }}: {{ item?.appliedDate | date : 'shortDate' }} </span>
            @defer (on viewport(candidateCard)) {
            <e11-overflow
              #applicationStatusActionOverflow
              *ngIf="!(item?.applicationState | isApplicationArchived)"
              (clickOptionEvent)="changeApplicationStatus($any($event))"
              [closeOnMouseOut]="true"
              [icon]="'expand_more'"
              [iconColor]="'primary'"
              [menuMaxWidth]="160"
              [menuPosition]="'bottom left'"
            >
              <li
                (click)="applicationStatusActionOverflow.clickOption(status, $event)"
                *ngFor="let status of applicationStatusOverflowOptions"
                class="e11-cursor-pointer"
                [class.mc-menu-item-danger]="status === APPLICATION_STATE.NOT_INTERESTED"
                custom-option
              >
                {{ status | applicationState }}
              </li>
            </e11-overflow>
            }
            <!-- Seen/Viewed? -->
            <ng-container *ngrxLet="applicationViewed$ as applicationViewed">
              <ng-container *ngrxLet="isUpdatingApplication$ as isUpdatingApplication">
                <span
                  *ngIf="!applicationViewed && !isUpdatingApplication"
                  class="material-icons md-14 e11-p-[3px] e11-text-skin-white e11-bg-skin-secondary e11-rounded-full"
                  [attr.title]="'You have not viewed this application' | translate"
                >
                  notifications_active
                </span>

                <e11-icon-loader classOverrides="e11-text-skin-primary" *ngIf="isUpdatingApplication"></e11-icon-loader>
              </ng-container>
            </ng-container>
          </div>
          <p class="e11-text-sm e11-font-primary-demibold" *ngIf="viewAll">
            {{ item?.applicationState || APPLICATION_STATE.APPLIED | applicationState }}
          </p>
          <p *ngIf="loading" class="e11-skeleton-empty e11-mb-2 !e11-w-[80%]"></p>
          <div *ngIf="loading" class="e11-flex e11-items-center">
            <p class="e11-skeleton-empty e11-mb-0 e11-mr-2 e11-w-full"></p>
            <div class="e11-skeleton-empty !e11-w-5 e11-h-5"></div>
          </div>

          @defer (on viewport(candidateCard)) {
          <!-- ICON SUMMARIES -->
          <ui-alg-card-icons
            [requestedUpdates]="item?.requestedUpdated"
            [hasFeedback]="item?.hasFeedback ?? false"
            [virtualDialogueCounts]="{
              pendingCount: item?.pendingVirtualDialogueCount,
              completedCount: item?.completedVirtualDialogueCount
            }"
            [totalApplicationShares]="item?.totalApplicationShares"
            *ngIf="item"
          />}
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngrxLet="canManageCultureIndex$ as canManageCultureIndex">
    <ng-container *ngIf="canManageCultureIndex">
      <ng-container>
        <e11-divider [margin]="0"></e11-divider>
        <div class="e11-flex e11-items-center e11-justify-between">
          <div class="e11-flex e11-gap-4 e11-items-center">
            <c-job-pattern
              [cJobPattern]="surveyMatchResult?.patternName ?? 'No Survey'"
              size="sm"
              [loading]="surveyLoading || loading"
            ></c-job-pattern>
            <span
              class="e11-text-xs e11-font-bold"
              *ngIf="loading || surveyLoading || surveyMatchResult"
              [ngClass]="{
                'e11-text-transparent e11-skeleton': surveyLoading || loading
              }"
              >{{ surveyMatchResult?.matcherPercentage }}% {{ 'match' | translate }}</span
            >
          </div>
          <div>
            <a
              *ngIf="surveyMatchResult && !loading && !surveyLoading"
              [href]="surveyMatchResult?.surveyReportUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="e11-text-skin-primary-accent e11-text-xs"
              (click)="onAnchorClick($event)"
              >{{ 'View Report' | translate }}</a
            >
            <span *ngIf="loading || surveyLoading" class="e11-skeleton e11-text-transparent e11-w-16 e11-h-6 e11-text-xs">View Report</span>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</e11-card>
